
import { mapState } from 'vuex';

  export default {
    computed: mapState({
      sectionBox: state => state.editor.sectionBox,
      hoverBox: state => state.editor.hoverBox,
      activeBox: state => state.editor.activeBox,
    }),
  }
